module.exports = __webpack_public_path__ + "static/media/about-bg-example-1.bc3e667b.jpg";